const Fetcher = require('od-modules/utils/fetcher');
const {apiRejected} = require('components/package_selection_info/dynpack_shopping_cart/data/dynpack_errors');
const SERVICE_NAME = 'shopping-cart';
const STATIC_RESOURCES = {
    createShoppingCart: 'create',
    modifyShoppingCart: 'modify',
    confirmShoppingCart: 'confirm',
    roomResults: 'room-results',
};
const buildRequestUrl = (resource) => (
    Odigeo.Settings.getProperty('dynpackUrlFormatter')(`${SERVICE_NAME}/${resource}`)
);
const onErrorCartService = () => ({dynpackErrors: apiRejected});

class CartService {
    static create(productSelection) {
        return Fetcher.post(buildRequestUrl(STATIC_RESOURCES.createShoppingCart), productSelection).json()
            .catch(onErrorCartService);
    }

    static modify(cartId, productSelection) {
        return Fetcher.put(buildRequestUrl(`${cartId}/${STATIC_RESOURCES.modifyShoppingCart}`), productSelection).json()
            .catch(onErrorCartService);
    }

    static confirm(cartId) {
        return Fetcher.post(buildRequestUrl(`${cartId}/${STATIC_RESOURCES.confirmShoppingCart}`), false).json()
            .catch(onErrorCartService);
    }

    static getProfile(cartId, profile) {
        return Fetcher.get(buildRequestUrl(`${cartId}/${profile}`)).json()
            .catch(onErrorCartService);
    }

    static getRoomResults(cartId) {
        return Fetcher.get(buildRequestUrl(`${cartId}/${STATIC_RESOURCES.roomResults}`)).json()
            .catch(onErrorCartService);
    }
}

module.exports = CartService;
